import { render, staticRenderFns } from "./TravelRoutes.vue?vue&type=template&id=5ef7685e"
import script from "./TravelRoutes.vue?vue&type=script&lang=js"
export * from "./TravelRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports